import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localizedDate',
})
export class LocalizedDatePipe implements PipeTransform {
  constructor() {}

  transform(value: any, format: string, locale: string): string {
    if (value == null) return '--';
    const datePipe: any = new DatePipe(locale);
    return datePipe.transform(new Date(value), format);
  }
}
